import React, { useContext } from 'react';
import {ModuloContext, SellerContext} from '../context/seller_context';
import '../assets/styles/search_seller_by_document.css';
import image2 from '../assets/images/icons/2-validar-informacion.png';

const GenerateReport = () => {
    const sellerContext = useContext(SellerContext);
    const moduloContext = useContext(ModuloContext);

    if (!sellerContext) {
        return <div>Error: SellerContext no está definido</div>;
    }

    const { seller } = sellerContext;

    if (!moduloContext) {
        return <div>Error: ModuloContext no está definido</div>;
    }

    const { module } = moduloContext;

    return (

    <div className="search-seller-container">
        <div className="icon-container">
            <div className="search-icon">
                <img src={image2} alt="Lock icon" className="icon"/>
            </div>
            <div className="search-container">
                <i className="fa-regular fa-address-card"></i>
                <div className="search-input">
                    <label htmlFor="documentNumber">GENERAR REPORTE - EN CONSTRUCCÍON</label>
                    <input
                        type="text"
                        id="documentNumber"
                        placeholder="Ingrese número de documento"
                    />
                    <button className="search-button">Buscar</button>
                </div>
            </div>
        </div>
    </div>
    );
};

export default GenerateReport;
